module.exports = __webpack_public_path__ + "img/look.com.ua-9243.46dd93b3.jpg";